const hasPoBox = address => {
  /* eslint-disable no-useless-escape */
  const re = /(^[\d\s]*p\.\s*[o0]\.([\s\d]+[\d\w\s\.]*)?$)|(^p[o0](b[o0])?([\s\d]+[\d\w\s\.]*)?$)|(^[\d\s]*p\s*[o0]\s*b\s*[o0]?\s*x([\s\d]+[\d\w\s\.]*)?$)|(^[\d\s]*p[o0](st(al)?)?\s*([o0]ffice(b[o0]x)?|bb?[o0]x|drawer)([\s\d]+[\d\w\s\.]*)?$)|(^[\d\s]*[o0]ffice\s*p[o0]st(al)?([\s\d]+[\d\w\s\.]*)?$)|(^[\d\s]*(p[o0]bx|pb[o0]x|p\s+b[o0]x|pbx|p\s+b|p\s+[0o]|p[o0]b|b[o0]x|drawer)([\s\d]+[\d\w\s\.]*)?$)|(^[\d\s]*b[o0]x\s+p\s*[o0](st(al)?)?\s*([o0]ffice)?([\s\d]+[\d\w\s\.]*)?$)/i;
  /* eslint-enable no-useless-escape */
  let o = address.replace(/[\\.,:;']/g, '');
  o = o.replace(/[_]/g, ' ');

  return !!o.match(re);
};

export default hasPoBox;
